import { Group, Skeleton, Stack } from '@mantine/core';
import React from 'react';

const LoaderCourseDetail = () => {
  return (
    <Stack gap={16}>
      <Skeleton h={100} />
      <Group align='flex-start'>
        <Stack flex={1}>
          <Skeleton h={400} />
          <Skeleton h={400} />
        </Stack>
        <Stack w={412}>
          <Skeleton h={200} />
          <Skeleton h={200} />
        </Stack>
      </Group>
    </Stack>
  );
};

export default LoaderCourseDetail;
